import React, { useEffect } from "react";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { useAppDispatch } from "../../redux/hooks";
import {
    getAllSitesRedux,
    getAplLinesRedux,
    getAplRolesRedux,
    getAplFeaturesRedux,
    getAplUsersRedux,
    getPrintersDepartmentAssignmentsRedux,
    onClearAdminRedux,
    setAddUserSiteId,
    setSelectedAplFeature,
    saveAplRoleFeaturesRedux,
    setSelectedAplFeatureDirtyRedux
} from "../../redux/slices/admin.feature";
import { useSelector } from "react-redux";
import { IRootState } from "../../types/redux/IRootStore";
import { userHasPermissionAnyLine } from "../../aplUtils/permissions";
import { UserPermission } from "../../types/userPermission";
import _ from "lodash";
import { DtGridPropsOptions2 } from "../../types/dtGridPropsOptions2";
import { AplFeature } from "../../types/aplFeature";
import { DtGrid2 } from "../common/DtGrid2";

const AdminRoleFeature = () => {
    const aplSettings = AplSettingsSelector();
    const isGlobalAdmin = userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.GlobalPermsAdmin);
    const dispatch = useAppDispatch();
    let adminRedux = useSelector((state: IRootState) => state.admin);

    const [selectedRole, setSelectedRole] = React.useState<number>(0);

    const selectedRolesFeatures = adminRedux.aplRoles.find(x => x.roleId === selectedRole)?.aplFeatures ?? [];

    React.useEffect(() => {
        dispatch(setAddUserSiteId(aplSettings.siteId));
        dispatch(isGlobalAdmin ? getAllSitesRedux(0) : (getAllSitesRedux(aplSettings.siteId) as any));
        dispatch(isGlobalAdmin ? getAplUsersRedux(0) : (getAplUsersRedux(aplSettings.siteId) as any));
        dispatch(isGlobalAdmin ? getAplLinesRedux(0) : (getAplLinesRedux(aplSettings.siteId) as any));
        dispatch(
            isGlobalAdmin ? getPrintersDepartmentAssignmentsRedux(0) : (getPrintersDepartmentAssignmentsRedux(aplSettings.siteId) as any)
        );
        dispatch(getAplRolesRedux() as any);
        dispatch(getAplFeaturesRedux() as any);
        return () => {
            dispatch(onClearAdminRedux());
            setSelectedRole(0);
        };
    }, [aplSettings.siteId, dispatch, isGlobalAdmin]);

    const updateSelectedRole = () => {
        dispatch(saveAplRoleFeaturesRedux({ roleId: selectedRole, features: adminRedux.selectedAplFeature }) as any);
    };

    const availableFeaturesGrid: DtGridPropsOptions2 = {
        data: adminRedux.aplFeatures,
        columnData: isGlobalAdmin
            ? [
                  {
                      data: "",
                      className: "select-checkbox pl-2 pr-2",
                      width: "2%",

                      title: ""
                  },
                  { data: "permissionType", className: "nowrap", width: "150%", title: "PermissionType" },
                  { data: "featureName", className: "nowrap", width: "150%", title: "FeatureName" }
              ]
            : [
                  { data: "permissionType", className: "nowrap", width: "150%", title: "PermissionType" },
                  { data: "featureName", className: "nowrap", width: "300%", title: "FeatureName" }
              ],
        defaultSort: {
            field: ["featureName"],
            direction: ["asc"]
        },
        selectType: "checkbox",
        colouring: true,
        headerFilters: false,
        filters: {},
        setFilters: function (x: any) {},
        setSelectedItems: function (x: AplFeature[]) {
            dispatch(setSelectedAplFeature(x));
            dispatch(setSelectedAplFeatureDirtyRedux(true));
        },
        selectedItems: adminRedux.selectedAplFeature,
        tableName: "availableFeaturesGrid",
        tableClass: "available-features-grid",
        paging: false,
        showSpinner: false,
        rowId: "permissionType",
        loading: false,
        pageLength: 1000,
        page: 1,
        setPage: _.noop
    };

    useEffect(() => {
        dispatch(setSelectedAplFeature(selectedRolesFeatures));
    }, [selectedRole]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-5>">
                    <select
                        className="form-control form-control-sm"
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            setSelectedRole(parseInt(e.currentTarget.value));
                            dispatch(setSelectedAplFeature([]));
                            dispatch(setSelectedAplFeatureDirtyRedux(false));
                        }}
                        value={selectedRole}
                    >
                        <option value={0}>Select Role</option>{" "}
                        {_.orderBy(adminRedux.aplRoles, x => x.roleName).map((role, index) => (
                            <option key={index} value={role.roleId}>{`${role.roleName} (RoleId=${role.roleId})`}</option>
                        ))}
                    </select>
                    <br />
                    <DtGrid2 options={availableFeaturesGrid} />
                    {isGlobalAdmin ? (
                        <button
                            onClick={updateSelectedRole}
                            className="btn btn-primary btn-sm"
                            disabled={!adminRedux.selectedAplFeatureDirty}
                        >
                            Update Role
                        </button>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default AdminRoleFeature;
